import * as React from 'react';

import './user-data.css';

interface UserDataProps extends React.HTMLAttributes<HTMLDivElement> {
  userData: {
    name: string;
    email: string;
    avatarImg?: string;
    role?: string;
  };
}

const UserData = React.forwardRef<HTMLDivElement, UserDataProps>(
  ({ userData, ...props }, ref) => {
    const generateTextAvatar = (name: string) =>
      `${name.split(' ')[0].slice(0, 1)}${name.split(' ')[1].slice(0, 1)}`;
    return (
      <div ref={ref} className="user-data" {...props}>
        <div className="user-data-content">
          <div className="user-data-content-avatar">
            {userData.avatarImg ? (
              <img src={userData.avatarImg} alt={`${userData.name}`} />
            ) : (
              <div className="user-data-content-avatar-default">
                {generateTextAvatar(userData.name)}
              </div>
            )}
          </div>
          <div className="user-data-content-data">
            <div className="user-data-content-data-name">{userData.name}</div>
            {userData.role === undefined ? (
              <div className="user-data-content-data-email">
                {userData.email}
              </div>
            ) : (
              <div className="user-data-content-data-role">{userData.role}</div>
            )}
          </div>
        </div>
      </div>
    );
  },
);

export { UserData };
